import { render } from "./SmSubHeader.vue?vue&type=template&id=81e92934&scoped=true"
import script from "./SmSubHeader.vue?vue&type=script&lang=js"
export * from "./SmSubHeader.vue?vue&type=script&lang=js"

import "./SmSubHeader.vue?vue&type=style&index=0&id=81e92934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e92934"]])

export default __exports__